export enum EmissionFrequency {
  millisecond = 'millisecond',
  second = 'second',
  minute = 'minute',
}

export enum Network {
  network4G = 'network4G',
  network5G = 'network5G',
  networkWired = 'networkWired',
  networkWireless = 'networkWireless',
  networkOther = 'networkOther'
}

export enum GatewayType {
  SoftGateway = 'SoftGateway',
  HardGateway = 'HardGateway'
}

export enum AutoLocation {
  YesAuto = 'true',
  NoAuto = 'false'
}

export enum NodeType {
  /**
   * 工厂
   */
  Customer = 'Customer',
  /**
   * 车间
   */
  Project = 'Project',
  /**
   * 用户
   */
  User = 'User',
  /**
   * 设备
   */
  Device = 'Device',
  /**
   * 未知
   */
  Organization = 'Organization',
  /**
   * 区域
   */
  LogicalGroup = 'LogicalGroup',
}


export const EmissionFrequencyList: Array<EmissionFrequency> = [EmissionFrequency.millisecond, EmissionFrequency.second, EmissionFrequency.minute];
export const NetworkList: Array<Network> = [Network.network4G, Network.network5G, Network.networkWired, Network.networkWireless, Network.networkOther];
export const GatewayTypeList: Array<GatewayType> = [GatewayType.SoftGateway, GatewayType.HardGateway];
export const AutoLocationList: Array<AutoLocation> = [AutoLocation.YesAuto, AutoLocation.NoAuto];
